<template>
  <div>
    <!--照片区域-->
    <input style="float: left;  display: none;" type="file" id="uploadFile" accept="image/*" @change="readLocalFile" /><!-- capture="camera" -->
  </div>
</template>

<script>
import { compress } from '@/utils/compress';
import { CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  data() {
    return {
      picInfo: {
        type: '',
        base64: '',
        small64: '',
        fileUrl: '',
        webUrl: '',
        blob: '',
      },
    };
  },
  methods: {
    // 图片click
    imgClick: function (type) {
      this.picInfo.type = type;
      this.picInfo.blob = '';
      this.picInfo.base64 = '';
      this.picInfo.small64 = '';
      this.picInfo.fileUrl = '';
      this.picInfo.webUrl = '';
      document.getElementById('uploadFile').click();
    },
    // 点击选中图片
    readLocalFile(e) {
      // 没有选择的时候返回、不提交
      if (!e.target.value) return;
      const that = this;
      CusLoadingOpen('压缩中...');
      // 读取文件，并加载图片
      const fileCtrl = document.getElementById('uploadFile');
      const localFile = fileCtrl.files[0];
      const reader = new FileReader();
      reader.onload = function (event) {
        const readerData = reader.result;
        // 获取图片宽、高
        const image = new Image();
        image.onload = function () {
          const imgWidth = image.width;
          const imgHeight = image.height;
          // 根据图片大小计算计算压缩质量
          const formatM = localFile.size / 1024 / 1024;
          let quality = 0.7;
          if (formatM < 3 && formatM > 2) {
            quality = 0.98;
          } else if (formatM < 4 && formatM > 3) {
            quality = 0.85;
          } else if (formatM < 5 && formatM > 4) {
            quality = 0.8;
          }
          // 判断是否小于2M
          // 如果大于2M，则进行压缩，反之不用压缩
          const isLt2M = localFile.size / 1024 / 1024 < 2;
          if (!isLt2M) {
            compress(localFile, imgWidth, imgHeight, quality, that.picInfo.type, function (newFile) {
              CusLoadingClose();
              that.picInfo.blob = newFile.blob;
              that.picInfo.small64 = newFile.base64;
              fileCtrl.value = '';
              that.emitGetImgInfo(readerData);
            });
          } else {
            CusLoadingClose();
            fileCtrl.value = '';
            that.emitGetImgInfo(readerData);
          }
        };
        image.src = readerData;
      };
      reader.onerror = function (event) {
        alert('error');
      };
      reader.readAsDataURL(localFile, 'UTF-8');
    },

    emitGetImgInfo(base64) {
      this.picInfo.base64 = base64; // 获取图片base64代码
      this.picInfo.fileUrl = document.getElementById('uploadFile').value;
      var inter = setInterval(() => {
        if (this.picInfo.base64) {
          // 设置data数据
          this.$emit('getImgInfo', {
            type: this.picInfo.type,
            blob: this.picInfo.blob,
            base64: this.picInfo.base64,
            small64: this.picInfo.small64,
            fileUrl: this.picInfo.fileUrl,
            webUrl: '',
          });
          clearInterval(inter);
        }
      }, 100);
    },
  },
};
</script>
